import { render, staticRenderFns } from "./ChurnDashboard.vue?vue&type=template&id=629857d7&scoped=true"
import script from "./ChurnDashboard.vue?vue&type=script&lang=ts"
export * from "./ChurnDashboard.vue?vue&type=script&lang=ts"
import style0 from "./ChurnDashboard.vue?vue&type=style&index=0&id=629857d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629857d7",
  null
  
)

export default component.exports